import { render, staticRenderFns } from "./PeriodComparator.vue?vue&type=template&id=a9a24826&"
import script from "./PeriodComparator.vue?vue&type=script&lang=ts&"
export * from "./PeriodComparator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports